<template>
	<div>
		<div class="page-title">
			<icon-font class="title-icon" type="icon-hunhemeiti" style="margin-right: 12px"/>
			<span>Google+AE-PC</span>
		</div>
		<a-tabs v-model="activeKey" class="page-tabs" type="card">
			<!-- <a-tab-pane key="account" tab="Appsflyer账号"></a-tab-pane> -->
			<a-tab-pane key="data" tab="Google+AE-PC数据"></a-tab-pane>
		</a-tabs>
		<div v-if="activeKey === 'account'">
			<af-account code="AF"></af-account>
		</div>
		<div v-if="activeKey === 'data'">
			<MediaData code="GG-PC-AE"></MediaData>
		</div>
	</div>
</template>
<script>
import MediaData from "./components/mediaData.vue"
import afAccount from "./components/afAccount.vue"

export default {
	name: 'ggAndAePc',
	data() {
		return {
			activeKey: 'data',
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
			data: [],
		}
	},
	methods: {
		openEC() {
			window.open('http://adpub.yeahtargeter.com/', '_blank')
		},
	},
	components: {
		MediaData,
		afAccount
	}
}
</script>
<style lang="less" scoped>
	.page-tabs {
		margin-top: 24px;
		padding-left: 24px;
		/deep/ .ant-tabs-bar {
			border-bottom: none;
		}
	}
</style>